import { schedulingApi } from "./scheduling.api";

export const {
  useSaveSchedulingCloseMutation,
  useSaveSchedulingMutation,
  useGetSchedulingsByDriverQuery,
  useLazyGetSchedulingsByDriverQuery,
  useListSchedulingDeletedByDriverInfiniteQuery,
  useLazyGetSchedulingByDriverLicensePlateQuery,
  useGetSchedulingByDriverLicensePlateQuery,
  useSaveSchedulingDeleteMutation,
  useGetSchedulingQuery,
  useLazyGetSchedulingQuery
} = schedulingApi;
